import { app } from '../../../app';

app.factory('PublicServices', PublicServices);

/** @ngInject */
function PublicServices($http) {

	var url ='app/rest/public_services/';
    return {
        getAllPublicServicesThatSupportSSO: getAllPublicServicesThatSupportSSO,
        getAllPublicServicesThatSupportSSOFiltered: getAllPublicServicesThatSupportSSOFiltered,
        getAllPublicServicesThatSupportSSOAnd2FAFiltered: getAllPublicServicesThatSupportSSOAnd2FAFiltered
    };

    function getAllPublicServicesThatSupportSSO() {
        return $http.get(url+'ssosupported')
            .then(response => response.data);
    }
    
    function getAllPublicServicesThatSupportSSOFiltered() {
        return $http.get(url+'ssosupportedfiltered')
            .then(response => response.data);
    }
    
    function getAllPublicServicesThatSupportSSOAnd2FAFiltered() {
        return $http.get(url+'ssoand2fasupported')
            .then(response => response.data);
    }
    
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/public-services.service.js